import Button from "components/atoms/Button";
import InputDate from "components/atoms/InputDate";
import InputField from "components/atoms/InputField";
import InputSelect from "components/atoms/InputSelect";
import { useFormik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Fasyankes from "services/Fasyankes";
import Ketenagaan from "services/Ketenagaan";
import Wilayah from "services/Wilayah";
import { errorToastNotif } from "utils/common";
import { PageMode, Source, UserLevel, YesAndNoOptions } from "utils/constant";
import InputCheckbox from "components/atoms/InputCheckbox";
import React from "react";

const WilayahService = new Wilayah();
const FasyankesService = new Fasyankes();
const ketenagaanService = new Ketenagaan();

const FormComponent = ({ selectedItem, pageMode, handlePageModeChange }) => {
  const [urbanvillages, setUrbanvillages] = useState([]);
  const { currentUser } = useSelector((state) => state.authReducer);
  const [levelIdValue, setLevelIdValue] = useState("");
  const [levelDataOptions, setLevelDataOptions] = useState({
    provinces: [],
    districts: [],
    fasyankes: [],
  });

  const [selectedProvince, setSelectedProvince] = useState(
    currentUser?.province_id
  );
  const [selectedDistrict, setSelectedDistrict] = useState(
    currentUser?.district_id
  );

  const fetchAllProvincies = async () => {
    try {
      const response = await WilayahService.getAll(Source.PROVINCE, {
        page: 1,
        limit: 9999,
      });
      setLevelDataOptions((prevState) => ({
        ...prevState,
        provinces: response.province.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDistrictByProvince = async (provinceId) => {
    try {
      const response = await WilayahService.getAll(Source.DISTRICT, {
        page: 1,
        limit: 9999,
        searchBy: "province_id",
        searchValue: provinceId,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        districts: response.district.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFasyankesByDistrict = async (districtId) => {
    try {
      const response = await FasyankesService.getAll(Source.FASYANKES, {
        page: 1,
        limit: 9999,
        searchBy: "district_id",
        searchValue: districtId,
        excludePkm: true,
      });

      setLevelDataOptions((prevState) => ({
        ...prevState,
        fasyankes: response.fasyankes.map((item) => {
          return {
            label: item.name,
            value: `${item.id}|${item.name}`,
          };
        }),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllProvincies();

    if (selectedProvince) {
      fetchDistrictByProvince(selectedProvince?.split("|")[0]);
    }
    if (selectedDistrict) {
      fetchFasyankesByDistrict(selectedDistrict?.split("|")[0]);
    }
  }, [selectedProvince, selectedDistrict]);

  const formik = useFormik({
    initialValues: {
      ///Location Information
      province_id: currentUser?.province_id,
      district_id: currentUser?.district_id,
      kd_faskes: "",
      namapetugas: "",

      ///Training Information
      plthsismal: "", //Ya/Tidak
      thnplthsismal: null, //(year)

      ///Medical Staff: Doctor
      dokterumum: "", //Ya/Tidak
      dokterumum_sosmal: "", //Ya/Tidak
      thn_dokterumum_sosmal: null, //(year)

      /// Internal Medicine Specialist
      dok_spd: "", //Ya/Tidak
      dok_spd_sosmal: "", //Ya/Tidak
      thn_dok_spd_sosmal: "", //(year)

      /// Pediatric Specialist
      dok_anak: "", //Ya/Tidak
      dok_anak_sosmal: "", //Ya/Tidak
      thn_dok_anak_sosmal: "", //(year)

      /// Obstetrician/Gynecologist Specialist
      dok_kand: "", //Ya/Tidak
      dokter_kand_sosmal: "", //Ya/Tidak
      thn_dokter_kand_sosmal: "", //(year)

      ///Medical Staff: Nurse
      perawat: "", //Ya/Tidak
      prwat_sosmal: "", //Ya/Tidak
      thn_jmlprwat_sosmal: null, //(year)
      prwt_skrining_sosmal_balita: "", //Ya/Tidak
      thn_jmlprwt_skrining_sosmal_balita: null, //(year)

      ///Medical Staff: Midwife
      bidan: "", //Ya/Tidak
      bidan_sosmal: "", //Ya/Tidak
      thn_jmlbidan_sosmal: null, //(year)
      bidan_sosmal_anc: "", //Ya/Tidak
      thn_jmlbidan_sosmal_anc: null, //(year)
      bidan_skrining_sosmal_balita: "", //Ya/Tidak
      thn_bidan_skrining_sosmal_balita: null, //(year)

      ///Clinical Pathologist Specialist
      dok_patologi: "", //Ya/Tidak
      dok_pato_sosmal: "", //Ya/Tidak
      thn_dok_pato_sosmal: "", //(year)

      ///Clinical Parasitologist Specialist
      dok_parasitologi: "", //Ya/Tidak
      dok_parasitologi_sosmal: "", //Ya/Tidak
      thn_dok_parasitologi_sosmal: "", //(year)
    },
    validate: (values) => {
      const errors = {};

      ///Location Information
      if (!values.kd_faskes) {
        errors.kd_faskes = "Nama Non Puskesmas wajib diisi";
      }

      if (!values.namapetugas) {
        errors.namapetugas = "Nama petugas surveilans/ rekam medik wajib diisi";
      }

      ///Training Information
      if (values.plthsismal === "Ya" && !values.thnplthsismal) {
        errors.thnplthsismal = "Tahun pelatihan terakhir wajib diisi";
      }

      ///Medical Staff: Doctor
      if (values.dokterumum === "Ya" && !values.dokterumum_sosmal) {
        errors.dokterumum_sosmal =
          "Ketersediaan dokter umum yang Tersosialisasi Tatalaksana Malaria wajib diisi";
      }

      if (values.dokterumum_sosmal === "Ya" && !values.thn_dokterumum_sosmal) {
        errors.thn_dokterumum_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Internal Medicine Specialist
      if (values.dok_spd === "Ya" && !values.dok_spd_sosmal) {
        errors.dok_spd_sosmal =
          "Ketersediaan dokter spesialis penyakit yang dalam yang sudah mendapatkan sosialisasi tatalaksana malaria wajib diisi";
      }

      if (values.dok_spd_sosmal === "Ya" && !values.thn_dok_spd_sosmal) {
        errors.thn_dok_spd_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Pediatric Specialist
      if (values.dok_anak === "Ya" && !values.dok_anak_sosmal) {
        errors.dok_anak_sosmal =
          "Ketersediaan dokter spesialis anak yang sudah mendapatkan sosialisasi tatalaksana malaria(0-50) wajib diisi";
      }

      if (values.dok_anak_sosmal === "Ya" && !values.thn_dok_anak_sosmal) {
        errors.thn_dok_anak_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Obstetrician/Gynecologist  Specialist
      if (values.dok_kand === "Ya" && !values.dokter_kand_sosmal) {
        errors.dokter_kand_sosmal =
          "Ketersediaan dokter spesialis kandungan yang sudah mendapatkan sosialisasi tatalaksana malaria wajib diisi";
      }

      if (
        values.dokter_kand_sosmal === "Ya" &&
        !values.thn_dokter_kand_sosmal
      ) {
        errors.thn_dokter_kand_sosmal =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Medical Staff: Nurse
      if (values.perawat === "Ya" && !values.prwat_sosmal) {
        errors.prwat_sosmal =
          "Ketersediaan Perawat yang Tersosialisasi Tatalaksana Malaria wajib diisi";
      }

      if (values.prwat_sosmal === "Ya" && !values.thn_jmlprwat_sosmal) {
        errors.thn_jmlprwat_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      if (values.perawat === "Ya" && !values.prwt_skrining_sosmal_balita) {
        errors.prwt_skrining_sosmal_balita =
          "Ketersediaan Perawat yang Tersosialisasi Skrining Malaria Pada Balita di Kab/Kota dengan Endemis Tinggi wajib diisi";
      }

      if (
        values.prwt_skrining_sosmal_balita === "Ya" &&
        !values.thn_jmlprwt_skrining_sosmal_balita
      ) {
        errors.thn_jmlprwt_skrining_sosmal_balita =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Medical Staff: Midwife
      if (values.bidan === "Ya" && !values.bidan_sosmal) {
        errors.bidan_sosmal =
          "Ketersediaan Bidan yang Tersosialisasi Tatalaksana Malaria wajib diisi";
      }

      if (values.bidan_sosmal === "Ya" && !values.thn_jmlbidan_sosmal) {
        errors.thn_jmlbidan_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      if (values.bidan === "Ya" && !values.bidan_sosmal_anc) {
        errors.bidan_sosmal_anc =
          "Ketersediaan Bidan yang Tersosialisasi Skrining Malaria Pada Ibu Hamil di Kab/Kota dengan Endemis Tinggi wajib diisi";
      }

      if (values.bidan_sosmal_anc === "Ya" && !values.thn_jmlbidan_sosmal_anc) {
        errors.thn_jmlbidan_sosmal_anc =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      if (values.bidan === "Ya" && !values.bidan_skrining_sosmal_balita) {
        errors.bidan_skrining_sosmal_balita =
          "Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi wajib diisi";
      }

      if (
        values.bidan_skrining_sosmal_balita === "Ya" &&
        !values.thn_bidan_skrining_sosmal_balita
      ) {
        errors.thn_bidan_skrining_sosmal_balita =
          "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Clinical Pathologist  Specialist
      if (values.dok_patologi === "Ya" && !values.dok_pato_sosmal) {
        errors.dok_pato_sosmal =
          "Ketersediaan dokter spesialis patologi klinik yg sudah mendapatkan sosialisasi QA diagnostik wajib diisi";
      }

      if (values.dok_pato_sosmal === "Ya" && !values.thn_dok_pato_sosmal) {
        errors.thn_dok_pato_sosmal = "Tahun sosialisasi terakhir wajib diisi";
      }

      ///Clinical Parasitologist  Specialist
      if (values.dok_parasitologi === "Ya" && !values.dok_parasitologi_sosmal) {
        errors.dok_parasitologi_sosmal =
          "Ketersediaan dokter spesialis parasitologi yg sudah mendapatkan sosialisasi QA diagnostik wajib diisi";
      }

      if (
        values.dok_parasitologi_sosmal === "Ya" &&
        !values.thn_dok_parasitologi_sosmal
      ) {
        errors.thn_dok_parasitologi_sosmal =
          "Tahun sosialisasi terakhir wajib diisi";
      }
      return errors;
    },
    onSubmit: async (values) => {
      const payload = {
        ///Location Information
        kd_prop: currentUser?.province_id
          ? currentUser.province_id.split("|")[0]
          : "",
        kd_kab: currentUser?.district_id
          ? currentUser.district_id.split("|")[0]
          : "",
        tgl_simpan: moment().format("YYYY-MM-DD"),
        tipefaskes: "2",
        id_tenaga: values.kd_faskes ? values.kd_faskes.split("|")[0] : "",
        kd_faskes: values.kd_faskes ? values.kd_faskes.split("|")[0] : "",
        namapetugas: values.namapetugas,

        ///Training Information
        plthsismal: values.plthsismal,
        thnplthsismal: values.thnplthsismal,

        ///Medical Staff: Doctor
        dokterumum: values.dokterumum,
        dokterumum_sosmal: values.dokterumum_sosmal,
        thn_dokterumum_sosmal: values.thn_dokterumum_sosmal,

        /// Internal Medicine Specialist
        dok_spd: values.dok_spd,
        dok_spd_sosmal: values.dok_spd_sosmal,
        thn_dok_spd_sosmal: values.thn_dok_spd_sosmal,

        /// Pediatric Specialist
        dok_anak: values.dok_anak,
        dok_anak_sosmal: values.dok_anak_sosmal,
        thn_dok_anak_sosmal: values.thn_dok_anak_sosmal,

        /// Obstetrician/Gynecologist Specialist
        dok_kand: values.dok_kand,
        dokter_kand_sosmal: values.dokter_kand_sosmal,
        thn_dokter_kand_sosmal: values.thn_dokter_kand_sosmal,

        ///Medical Staff: Nurse
        perawat: values.perawat,
        prwat_sosmal: values.prwat_sosmal,
        thn_jmlprwat_sosmal: values.thn_jmlprwat_sosmal,
        prwt_skrining_sosmal_balita: values.prwt_skrining_sosmal_balita,
        thn_jmlprwt_skrining_sosmal_balita:
          values.thn_jmlprwt_skrining_sosmal_balita,

        ///Medical Staff: Midwife
        bidan: values.bidan,
        bidan_sosmal: values.bidan_sosmal,
        thn_jmlbidan_sosmal: values.thn_jmlbidan_sosmal,
        bidan_sosmal_anc: values.bidan_sosmal_anc,
        thn_jmlbidan_sosmal_anc: values.thn_jmlbidan_sosmal_anc,
        bidan_skrining_sosmal_balita: values.bidan_skrining_sosmal_balita,
        thn_bidan_skrining_sosmal_balita:
          values.thn_bidan_skrining_sosmal_balita,

        ///Clinical Pathologist Specialist
        dok_patologi: values.dok_patologi,
        dok_pato_sosmal: values.dok_pato_sosmal,
        thn_dok_pato_sosmal: values.thn_dok_pato_sosmal,

        ///Clinical Parasitologist Specialist
        dok_parasitologi: values.dok_parasitologi,
        dok_parasitologi_sosmal: values.dok_parasitologi_sosmal,
        thn_dok_parasitologi_sosmal: values.thn_dok_parasitologi_sosmal,
      };

      switch (pageMode) {
        case PageMode.add:
          await ketenagaanService
            .add(payload)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Ketenagaan berhasil ditambahkan", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
        case PageMode.edit:
          await ketenagaanService
            .update(payload, selectedItem?.kd_id)
            .then((res) => {
              handlePageModeChange(PageMode.view);
              toast.success("Data Ketenagaan berhasil diupdate", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: "colored",
                draggable: true,
              });
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  const getUrbanvillagesByCurrentUser = async () => {
    try {
      const response = await WilayahService.getAll(Source.URBANVILLAGE, {
        searchBy: "subdistrict_id",
        searchValue: currentUser?.subdistrict_id?.split("|")[0],
        page: 1,
        limit: 9999,
      });
      setUrbanvillages(response.urbanvillage);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUrbanvillagesByCurrentUser();
  }, []);

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      formik.setValues({
        kd_faskes: selectedItem.kd_faskes,
        namapetugas: selectedItem.namapetugas,

        ///Training Information
        plthsismal: selectedItem.plthsismal,
        thnplthsismal: selectedItem.thnplthsismal,

        ///Medical Staff: Doctor
        dokterumum: selectedItem.dokterumum,
        dokterumum_sosmal: selectedItem.dokterumum_sosmal,
        thn_dokterumum_sosmal: selectedItem.thn_dokterumum_sosmal,

        /// Internal Medicine Specialist
        dok_spd: selectedItem.dok_spd,
        dok_spd_sosmal: selectedItem.dok_spd_sosmal,
        thn_dok_spd_sosmal: selectedItem.thn_dok_spd_sosmal,

        /// Pediatric Specialist
        dok_anak: selectedItem.dok_anak,
        dok_anak_sosmal: selectedItem.dok_anak_sosmal,
        thn_dok_anak_sosmal: selectedItem.thn_dok_anak_sosmal,

        /// Obstetrician/Gynecologist Specialist
        dok_kand: selectedItem.dok_kand,
        dokter_kand_sosmal: selectedItem.dokter_kand_sosmal,
        thn_dokter_kand_sosmal: selectedItem.thn_dokter_kand_sosmal,

        ///Medical Staff: Nurse
        perawat: selectedItem.perawat,
        prwat_sosmal: selectedItem.prwat_sosmal,
        thn_jmlprwat_sosmal: selectedItem.thn_jmlprwat_sosmal,
        prwt_skrining_sosmal_balita: selectedItem.prwt_skrining_sosmal_balita,
        thn_jmlprwt_skrining_sosmal_balita:
          selectedItem.thn_jmlprwt_skrining_sosmal_balita,

        ///Medical Staff: Midwife
        bidan: selectedItem.bidan,
        bidan_sosmal: selectedItem.bidan_sosmal,
        thn_jmlbidan_sosmal: selectedItem.thn_jmlbidan_sosmal,
        bidan_sosmal_anc: selectedItem.bidan_sosmal_anc,
        thn_jmlbidan_sosmal_anc: selectedItem.thn_jmlbidan_sosmal_anc,
        bidan_skrining_sosmal_balita: selectedItem.bidan_skrining_sosmal_balita,
        thn_bidan_skrining_sosmal_balita:
          selectedItem.thn_bidan_skrining_sosmal_balita,

        ///Clinical Pathologist Specialist
        dok_patologi: selectedItem.dok_patologi,
        dok_pato_sosmal: selectedItem.dok_pato_sosmal,
        thn_dok_pato_sosmal: selectedItem.thn_dok_pato_sosmal,

        ///Clinical Parasitologist Specialist
        dok_parasitologi: selectedItem.dok_parasitologi,
        dok_parasitologi_sosmal: selectedItem.dok_parasitologi_sosmal,
        thn_dok_parasitologi_sosmal: selectedItem.thn_dok_parasitologi_sosmal,
      });
    }
  }, [selectedItem]);
  return (
    <>
      <h1 className="page-title">
        {pageMode === PageMode.add
          ? "Tambah Ketenagaan - RS/Klinik"
          : "Edit Ketenagaan - RS/Klinik"}
      </h1>

      <div className="form-grouping">
        <p
          className="warning"
          style={{ marginTop: "24px", marginBottom: "24px" }}
        >
          NOTE<span>*(WAJIB DIISI)</span>
        </p>

        <div className="row">
          <div className="col-sm-6 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Provinsi"}
              data={levelDataOptions.provinces}
              onChange={(e) => {
                setSelectedProvince(e.value);
                setSelectedDistrict("");
              }}
              value={
                levelDataOptions.provinces?.find(
                  (item) => item.value === selectedProvince
                ) || ""
              }
              isDisabled={true}
            />
          </div>
          <div className="col-sm-6 mb-3">
            <InputSelect
              isClearable={false}
              placeholder={"Pilih Kab/Kota"}
              data={levelDataOptions.districts}
              onChange={(e) => {
                setSelectedDistrict(e.value);
              }}
              value={
                levelDataOptions.districts?.find(
                  (item) => item.value === selectedDistrict
                ) || ""
              }
              isDisabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4 mb-3">
            <InputSelect
              isClearable={false}
              isMultipleSelect={false}
              label={"Fasyankes non puskesmas"}
              placeholder={"Pilih Fasyankes non puskesmas"}
              data={levelDataOptions.fasyankes}
              onChange={(e) => {
                formik.setFieldValue("kd_faskes", e.value);
              }}
              value={
                levelDataOptions.fasyankes?.find(
                  (option) =>
                    option.value.split("|")[0] === formik.values.kd_faskes
                ) || null
              }
              isRequired={true}
            />
          </div>
          <div className="col-sm-4 mb-3">
            <InputField
              label={"Nama petugas surveilans/ rekam medik"}
              name={"namapetugas"}
              placeholder={"Masukkan Nama petugas surveilans/ rekam medik"}
              type={"text"}
              {...formik.getFieldProps("namapetugas")}
              error={formik.errors.namapetugas && formik.touched.namapetugas}
              errorMessage={formik.errors.namapetugas}
              value={formik.values.namapetugas}
              isRequired={true}
            />
          </div>
          <div className="col-sm-4 mb-3">
            <div className="d-flex flex-column gap-3">
              <div>
                <InputCheckbox
                  options={[{ label: "Pelatihan SISMAL", value: "Ya" }]}
                  name="plthsismal"
                  onChange={(e) => {
                    const selectedValue = e.target.checked ? "Ya" : "Tidak";

                    if (selectedValue !== "Ya") {
                      formik.setFieldValue("thnplthsismal", "");
                    }
                    formik.handleChange("plthsismal")(selectedValue);
                  }}
                  onBlur={formik.handleBlur}
                  selectedOption={formik.values.plthsismal}
                  error={formik.errors.plthsismal && formik.touched.plthsismal}
                  errorMessage={formik.errors.plthsismal}
                />
              </div>
              <div>
                <InputDate
                  name={"thnplthsismal"}
                  placeholder={"Pilih Tahun pelatihan terakhir"}
                  value={
                    formik.values.thnplthsismal
                      ? moment(formik.values.thnplthsismal, "YYYY")
                      : null
                  }
                  onChange={(e) => {
                    const selectedYear = moment(e).format("YYYY");
                    formik.setFieldValue("thnplthsismal", selectedYear);
                  }}
                  dateFormat={"YYYY"}
                  onBlur={formik.handleBlur}
                  error={
                    formik.errors.thnplthsismal && formik.touched.thnplthsismal
                  }
                  errorMessage={formik.errors.thnplthsismal}
                  isDisabled={formik.values.plthsismal !== "Ya"}
                  isValidDate={(current) => current.year() <= moment().year()}
                />
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter umum?"}
              name={"dokterumum"}
              placeholder={"Pilih Ketersediaan dokter umum?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dokterumum", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dokterumum_sosmal", "");
                  formik.setFieldValue("thn_dokterumum_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dokterumum
              )}
              error={formik.errors.dokterumum && formik.touched.dokterumum}
              errorMessage={formik.errors.dokterumum}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter umum yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"dokterumum_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter umum yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dokterumum_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dokterumum_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dokterumum_sosmal
              )}
              error={
                formik.errors.dokterumum_sosmal &&
                formik.touched.dokterumum_sosmal
              }
              errorMessage={formik.errors.dokterumum_sosmal}
              disabled={formik.values.dokterumum !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dokterumum_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dokterumum_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dokterumum_sosmal
                  ? moment(formik.values.thn_dokterumum_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dokterumum_sosmal &&
                formik.touched.thn_dokterumum_sosmal
              }
              errorMessage={formik.errors.thn_dokterumum_sosmal}
              isDisabled={formik.values.dokterumum_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis penyakit dalam?"}
              name={"dok_spd"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis penyakit dalam?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_spd", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dok_spd_sosmal", "");
                  formik.setFieldValue("thn_dok_spd_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_spd
              )}
              error={formik.errors.dok_spd && formik.touched.dok_spd}
              errorMessage={formik.errors.dok_spd}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis penyakit yang dalam yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"dok_spd_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis penyakit yang dalam yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_spd_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dok_spd_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_spd_sosmal
              )}
              error={
                formik.errors.dok_spd_sosmal && formik.touched.dok_spd_sosmal
              }
              errorMessage={formik.errors.dok_spd_sosmal}
              disabled={formik.values.dok_spd !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dok_spd_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dok_spd_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dok_spd_sosmal
                  ? moment(formik.values.thn_dok_spd_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dok_spd_sosmal &&
                formik.touched.thn_dok_spd_sosmal
              }
              errorMessage={formik.errors.thn_dok_spd_sosmal}
              isDisabled={formik.values.dok_spd_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis anak?"}
              name={"dok_anak"}
              placeholder={"Pilih Ketersediaan dokter spesialis anak?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_anak", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dok_anak_sosmal", "");
                  formik.setFieldValue("thn_dok_anak_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_anak
              )}
              error={formik.errors.dok_anak && formik.touched.dok_anak}
              errorMessage={formik.errors.dok_anak}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis anak yang sudah mendapatkan sosialisasi tatalaksana malaria(0-50)"
              }
              name={"dok_anak_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis anak yang sudah mendapatkan sosialisasi tatalaksana malaria(0-50)"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_anak_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dok_anak_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_anak_sosmal
              )}
              error={
                formik.errors.dok_anak_sosmal && formik.touched.dok_anak_sosmal
              }
              errorMessage={formik.errors.dok_anak_sosmal}
              disabled={formik.values.dok_anak !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dok_anak_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dok_anak_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dok_anak_sosmal
                  ? moment(formik.values.thn_dok_anak_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dok_anak_sosmal &&
                formik.touched.thn_dok_anak_sosmal
              }
              errorMessage={formik.errors.thn_dok_anak_sosmal}
              isDisabled={formik.values.dok_anak_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>

        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis kandungan?"}
              name={"dok_kand"}
              placeholder={"Pilih Ketersediaan dokter spesialis kandungan?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_kand", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dokter_kand_sosmal", "");
                  formik.setFieldValue("thn_dokter_kand_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_kand
              )}
              error={formik.errors.dok_kand && formik.touched.dok_kand}
              errorMessage={formik.errors.dok_kand}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis kandungan yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"dokter_kand_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis kandungan yang sudah mendapatkan sosialisasi tatalaksana malaria"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dokter_kand_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dokter_kand_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dokter_kand_sosmal
              )}
              error={
                formik.errors.dokter_kand_sosmal &&
                formik.touched.dokter_kand_sosmal
              }
              errorMessage={formik.errors.dokter_kand_sosmal}
              disabled={formik.values.dok_kand !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dokter_kand_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dokter_kand_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dokter_kand_sosmal
                  ? moment(formik.values.thn_dokter_kand_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dokter_kand_sosmal &&
                formik.touched.thn_dokter_kand_sosmal
              }
              errorMessage={formik.errors.thn_dokter_kand_sosmal}
              isDisabled={formik.values.dokter_kand_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan perawat?"}
              name={"perawat"}
              placeholder={"Pilih Ketersediaan perawat?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("perawat", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("prwat_sosmal", "");
                  formik.setFieldValue("thn_jmlprwat_sosmal", "");
                  formik.setFieldValue("prwt_skrining_sosmal_balita", "");
                  formik.setFieldValue(
                    "thn_jmlprwt_skrining_sosmal_balita",
                    ""
                  );
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.perawat
              )}
              error={formik.errors.perawat && formik.touched.perawat}
              errorMessage={formik.errors.perawat}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan perawat yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"prwat_sosmal"}
              placeholder={
                "Pilih Ketersediaan perawat yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("prwat_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_jmlprwat_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.prwat_sosmal
              )}
              error={formik.errors.prwat_sosmal && formik.touched.prwat_sosmal}
              errorMessage={formik.errors.prwat_sosmal}
              disabled={formik.values.perawat !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlprwat_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_jmlprwat_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlprwat_sosmal
                  ? moment(formik.values.thn_jmlprwat_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_jmlprwat_sosmal &&
                formik.touched.thn_jmlprwat_sosmal
              }
              errorMessage={formik.errors.thn_jmlprwat_sosmal}
              isDisabled={formik.values.prwat_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan perawat yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              name={"prwt_skrining_sosmal_balita"}
              placeholder={
                "Pilih Ketersediaan perawat yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue(
                  "prwt_skrining_sosmal_balita",
                  selectedValue
                );
                if (selectedValue !== "Ya") {
                  formik.setFieldValue(
                    "thn_jmlprwt_skrining_sosmal_balita",
                    ""
                  );
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) =>
                  option.value === formik.values.prwt_skrining_sosmal_balita
              )}
              error={
                formik.errors.prwt_skrining_sosmal_balita &&
                formik.touched.prwt_skrining_sosmal_balita
              }
              errorMessage={formik.errors.prwt_skrining_sosmal_balita}
              disabled={formik.values.perawat !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlprwt_skrining_sosmal_balita"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue(
                  "thn_jmlprwt_skrining_sosmal_balita",
                  selectedYear
                );
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlprwt_skrining_sosmal_balita
                  ? moment(
                      formik.values.thn_jmlprwt_skrining_sosmal_balita,
                      "YYYY"
                    )
                  : null
              }
              error={
                formik.errors.thn_jmlprwt_skrining_sosmal_balita &&
                formik.touched.thn_jmlprwt_skrining_sosmal_balita
              }
              errorMessage={formik.errors.thn_jmlprwt_skrining_sosmal_balita}
              isDisabled={formik.values.prwt_skrining_sosmal_balita !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan bidan?"}
              name={"bidan"}
              placeholder={"Pilih Ketersediaan bidan?"}
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("bidan", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("bidan_sosmal", "");
                  formik.setFieldValue("thn_jmlbidan_sosmal", "");
                  formik.setFieldValue("bidan_sosmal_anc", "");
                  formik.setFieldValue("thn_jmlbidan_sosmal_anc", "");
                  formik.setFieldValue("bidan_skrining_sosmal_balita", "");
                  formik.setFieldValue("thn_bidan_skrining_sosmal_balita", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.bidan
              )}
              error={formik.errors.bidan && formik.touched.bidan}
              errorMessage={formik.errors.bidan}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan bidan yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              name={"bidan_sosmal"}
              placeholder={
                "Pilih Ketersediaan bidan yang sudah mendapatkan sosialisasi tatalaksana malaria?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("bidan_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_jmlbidan_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.bidan_sosmal
              )}
              error={formik.errors.bidan_sosmal && formik.touched.bidan_sosmal}
              errorMessage={formik.errors.bidan_sosmal}
              disabled={formik.values.bidan !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlbidan_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_jmlbidan_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlbidan_sosmal
                  ? moment(formik.values.thn_jmlbidan_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_jmlbidan_sosmal &&
                formik.touched.thn_jmlbidan_sosmal
              }
              errorMessage={formik.errors.thn_jmlbidan_sosmal}
              isDisabled={formik.values.bidan_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada kegiatan ANC di kab/kota dengan endemis tinggi?"
              }
              name={"bidan_sosmal_anc"}
              placeholder={
                "Pilih Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada kegiatan ANC di kab/kota dengan endemis tinggi?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("bidan_sosmal_anc", selectedValue);

                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_jmlbidan_sosmal_anc", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.bidan_sosmal_anc
              )}
              error={
                formik.errors.bidan_sosmal_anc &&
                formik.touched.bidan_sosmal_anc
              }
              errorMessage={formik.errors.bidan_sosmal_anc}
              disabled={formik.values.bidan !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_jmlbidan_sosmal_anc"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_jmlbidan_sosmal_anc", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_jmlbidan_sosmal_anc
                  ? moment(formik.values.thn_jmlbidan_sosmal_anc, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_jmlbidan_sosmal_anc &&
                formik.touched.thn_jmlbidan_sosmal_anc
              }
              errorMessage={formik.errors.thn_jmlbidan_sosmal_anc}
              isDisabled={formik.values.bidan_sosmal_anc !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              name={"bidan_skrining_sosmal_balita"}
              placeholder={
                "Pilih Ketersediaan bidan yang sudah mendapatkan sosialisasi skrining malaria pada balita di kab/kota dengan endemis tinggi?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue(
                  "bidan_skrining_sosmal_balita",
                  selectedValue
                );
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_bidan_skrining_sosmal_balita", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) =>
                  option.value === formik.values.bidan_skrining_sosmal_balita
              )}
              error={
                formik.errors.bidan_skrining_sosmal_balita &&
                formik.touched.bidan_skrining_sosmal_balita
              }
              errorMessage={formik.errors.bidan_skrining_sosmal_balita}
              disabled={formik.values.bidan !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_bidan_skrining_sosmal_balita"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue(
                  "thn_bidan_skrining_sosmal_balita",
                  selectedYear
                );
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_bidan_skrining_sosmal_balita
                  ? moment(
                      formik.values.thn_bidan_skrining_sosmal_balita,
                      "YYYY"
                    )
                  : null
              }
              error={
                formik.errors.thn_bidan_skrining_sosmal_balita &&
                formik.touched.thn_bidan_skrining_sosmal_balita
              }
              errorMessage={formik.errors.thn_bidan_skrining_sosmal_balita}
              isDisabled={formik.values.bidan_skrining_sosmal_balita !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis patologi klinik?"}
              name={"dok_patologi"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis patologi klinik?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_patologi", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dok_pato_sosmal", "");
                  formik.setFieldValue("thn_dok_pato_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_patologi
              )}
              error={formik.errors.dok_patologi && formik.touched.dok_patologi}
              errorMessage={formik.errors.dok_patologi}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis patologi klinik yg sudah mendapatkan sosialisasi QA diagnostik?"
              }
              name={"dok_pato_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis patologi klinik yg sudah mendapatkan sosialisasi QA diagnostik?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_pato_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dok_pato_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_pato_sosmal
              )}
              error={
                formik.errors.dok_pato_sosmal && formik.touched.dok_pato_sosmal
              }
              errorMessage={formik.errors.dok_pato_sosmal}
              disabled={formik.values.dok_patologi !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dok_pato_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue("thn_dok_pato_sosmal", selectedYear);
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dok_pato_sosmal
                  ? moment(formik.values.thn_dok_pato_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dok_pato_sosmal &&
                formik.touched.thn_dok_pato_sosmal
              }
              errorMessage={formik.errors.thn_dok_pato_sosmal}
              isDisabled={formik.values.dok_pato_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-sm-12">
            <InputSelect
              label={"Ketersediaan dokter spesialis parasitologi klinik?"}
              name={"dok_parasitologi"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis parasitologi klinik?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_parasitologi", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("dok_parasitologi_sosmal", "");
                  formik.setFieldValue("thn_dok_parasitologi_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) => option.value === formik.values.dok_parasitologi
              )}
              error={
                formik.errors.dok_parasitologi &&
                formik.touched.dok_parasitologi
              }
              errorMessage={formik.errors.dok_parasitologi}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <InputSelect
              label={
                "Ketersediaan dokter spesialis parasitologi klinik yg sudah mendapatkan sosialisasi QA diagnostik?"
              }
              name={"dok_parasitologi_sosmal"}
              placeholder={
                "Pilih Ketersediaan dokter spesialis parasitologi klinik yg sudah mendapatkan sosialisasi QA diagnostik?"
              }
              data={YesAndNoOptions}
              onChange={(e) => {
                const selectedValue = e?.value ?? "";
                formik.setFieldValue("dok_parasitologi_sosmal", selectedValue);
                if (selectedValue !== "Ya") {
                  formik.setFieldValue("thn_dok_parasitologi_sosmal", "");
                }
              }}
              onBlur={formik.handleBlur}
              value={YesAndNoOptions.find(
                (option) =>
                  option.value === formik.values.dok_parasitologi_sosmal
              )}
              error={
                formik.errors.dok_parasitologi_sosmal &&
                formik.touched.dok_parasitologi_sosmal
              }
              errorMessage={formik.errors.dok_parasitologi_sosmal}
              disabled={formik.values.dok_parasitologi !== "Ya"}
            />
          </div>
          <div className="col-sm-6">
            <InputDate
              label={"Tahun sosialisasi terakhir"}
              name={"thn_dok_parasitologi_sosmal"}
              placeholder={"Pilih Tahun sosialisasi terakhir"}
              dateFormat={"YYYY"}
              onChange={(e) => {
                const selectedYear = moment(e).format("YYYY");
                formik.setFieldValue(
                  "thn_dok_parasitologi_sosmal",
                  selectedYear
                );
              }}
              onBlur={formik.handleBlur}
              value={
                formik.values.thn_dok_parasitologi_sosmal
                  ? moment(formik.values.thn_dok_parasitologi_sosmal, "YYYY")
                  : null
              }
              error={
                formik.errors.thn_dok_parasitologi_sosmal &&
                formik.touched.thn_dok_parasitologi_sosmal
              }
              errorMessage={formik.errors.thn_dok_parasitologi_sosmal}
              isDisabled={formik.values.dok_parasitologi_sosmal !== "Ya"}
              isValidDate={(current) => current.year() <= moment().year()}
            />
          </div>
        </div>
        {/* Action button */}
        <div className="button_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => handlePageModeChange(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            type={"submit"}
            variant={"primary"}
            size={"normal"}
            onClick={formik.handleSubmit}
            isDisabled={
              formik.isSubmitting ||
              !formik.values.kd_faskes ||
              !formik.values.namapetugas
            }
          >
            {pageMode === PageMode.edit ? "Ubah Data" : "Simpan Data"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default FormComponent;
